import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

/**
 * Storage utility that uses Capacitor Preferences on native platforms
 * and localStorage on web for compatibility
 */

const isNative = () => Capacitor.isNativePlatform();

export const storage = {
  async get(key) {
    try {
      if (isNative()) {
        const { value } = await Preferences.get({ key });
        return value;
      } else {
        return localStorage.getItem(key);
      }
    } catch (error) {
      console.error('Storage get error:', error);
      return localStorage.getItem(key);
    }
  },

  async set(key, value) {
    try {
      if (isNative()) {
        await Preferences.set({ key, value });
      } else {
        localStorage.setItem(key, value);
      }
    } catch (error) {
      console.error('Storage set error:', error);
      localStorage.setItem(key, value);
    }
  },

  async remove(key) {
    try {
      if (isNative()) {
        await Preferences.remove({ key });
      } else {
        localStorage.removeItem(key);
      }
    } catch (error) {
      console.error('Storage remove error:', error);
      localStorage.removeItem(key);
    }
  },

  async clear() {
    try {
      if (isNative()) {
        await Preferences.clear();
      } else {
        localStorage.clear();
      }
    } catch (error) {
      console.error('Storage clear error:', error);
      localStorage.clear();
    }
  }
};

export default storage;
